import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BookState {
    data: any[];
}

const initialState: BookState = {
    data: [],
};

const booksSlice = createSlice({
    name: 'books',
    initialState,
    reducers: {
        setBooksData: (state, action: PayloadAction<any[]>) => {
            state.data = action.payload;
        },
    },
});

export const { setBooksData } = booksSlice.actions;
export default booksSlice.reducer;
